// extracted by mini-css-extract-plugin
export default {"primeRadio":"Radio_primeRadio__86DJf","partnerRadio":"Radio_partnerRadio__kv-ao"};